import React from "react";
import { Row } from "reactstrap";
import { Link, useLocation } from "react-router-dom";

const NavlinksMobileTrial = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <>
      <Row>
        <Link
          to="/trial"
          className={`
            p-1 ps-3 rounded-3 responsive-fontsize fw-bold
            ${currentPath === "/trial" ? "navlink-focused" : "navlink"}
          `}
        >
          UtbudsMix
        </Link>
      </Row>

      <Row>
        <Link
          to="/trial/fastaKostnader"
          className={`
            mt-1 p-1 ps-3 rounded-3 responsive-fontsize fw-bold
            ${
              currentPath === "/trial/fastaKostnader"
                ? "navlink-focused"
                : "navlink"
            }
          `}
        >
          Fasta Kostnader
        </Link>
      </Row>

      <Row>
        <div
          className="mt-1 p-1 ps-3 rounded-3 responsive-fontsize fw-bold navlink"
          style={{ opacity: 0.5, pointerEvents: "none" }}
        >
          Lönekalkyl
        </div>
      </Row>

      <Row>
        <div
          className="mt-1 p-1 ps-3 rounded-3 responsive-fontsize fw-bold navlink"
          style={{ opacity: 0.5, pointerEvents: "none" }}
        >
          Åtgärder
        </div>
      </Row>
    </>
  );
};

export default NavlinksMobileTrial;
